import httpClient, { ConexaResponse } from '@/services/httpClient'

import type {
  CardType,
  ICard,
  ICardResponse,
  // ICardFlagInfo,
  IAddCardParams,
  ICardPostResponse,
  ICep,
  ICepResponse,
  ISpecialityPrices,
  ISpecialityPricesResponse,
  CouponApplyingResponse,
  IRequestPixPaymentParams,
  IRequestPixPaymentResponseRaw,
  IRequestImmediate,
  IRequestScheduled,
  CreateAttendanceRecurrenceParams,
  ConfirmReservationConsultationData,
} from './types'
import { PixPaymentMapper } from './mappers/PixPaymentMapper'
import { CancelToken } from 'axios'
import { RequestImmediatePixMapper } from './mappers/RequestImmediatePixMapper'
import { RequestScheduleAttendancePixMapper } from './mappers/RequestScheduleAttendancePixMapper'
import { ValidateTransactionMapper } from './mappers/ValidateTransactionMapper'
import { IConexaResponse } from '@/@types'
import { CreateAttendanceRecurrenceMapper } from './mappers/CreateAttendanceRecurrenceMapper'
import ConfirmReservationConsultationMapper from './mappers/ConfirmReservationConsultationMapper'

export const getAllCards = async (
  type: CardType,
  council?: string,
): Promise<ICard[]> => {
  let url = `/integration/app-paciente/financeiro/cartoes/listar?tipo=${type}`

  if (council) {
    url += `&tipoConselho=${council}`
  }
  const response = await httpClient.get<ConexaResponse<ICardResponse[]>>(url)

  const cards = response?.data?.object?.map(card => {
    return {
      id: card.id,
      finalCardNumbers: card.finalCartao,
      type: card.tipo,
      flag: card.bandeira,
      flagURL: card.urlBandeira,
      isDefault: card.flagDefault,
    }
  })

  return cards
}

export const deleteCard = async (cardId: number): Promise<boolean> => {
  const response = await httpClient.post<ConexaResponse<boolean>>(
    `/integration/app-paciente/financeiro/cartoes/excluir/${cardId}`,
  )

  return response?.data?.object
}
// export const getCardFlagInfo = async (
//   cardNumber: string,
// ): Promise<ICardFlagInfo> => {
//   const response = await httpClient.post<ConexaResponse<ICardFlagInfo>>(
//     '/integration/app-paciente/financeiro/obter/bandeira_cartao',
//     {
//       number: cardNumber,
//     },
//   )
//   return response?.data?.object
// }

export const getCep = async (cep: string): Promise<ICep> => {
  const response = await httpClient.get<ConexaResponse<ICepResponse>>(
    `/site/cep/${cep}`,
  )
  const address: ICep = {
    district: response.data.object.bairro,
    city: response.data.object.localidade,
    address: response.data.object.logradouro,
    state: response.data.object.uf,
  }
  return address
}

export const addCard = async ({
  // cardFlag,
  numeroCartao,
  nomeCartao,
  codigo,
  validade,
  cartaoPadrao,
  tipo,
  captchaToken,
  concil,
}: IAddCardParams): Promise<number> => {
  const { data } = await httpClient.post<ConexaResponse<ICardPostResponse>>(
    '/integration/app-paciente/financeiro/cartoes/salvar',
    {
      // bandeira: cardFlag,
      nomeCartao,
      numeroCartao,
      codigoSegurancaCartao: codigo,
      validadeCartao: validade,
      flagCartaoDefault: cartaoPadrao,
      tipo,
      tipoConselho: concil,
    },
    {
      headers: {
        captcha: captchaToken,
      },
    },
  )

  return data.object.idCartao
}

export const getSpecialityPrices = async (
  professionalType: string,
): Promise<ISpecialityPrices> => {
  const response = await httpClient.get<
    ConexaResponse<ISpecialityPricesResponse>
  >(
    `/integration/app-paciente/financeiro/obter/valores/tipo-profissional/${professionalType}`,
  )
  const prices: ISpecialityPrices = {
    immediatePrice: response.data.object.valorImadiato,
    scheduledPrice: response.data.object.valorAgendado,
  }
  return prices
}

export const getMedicPrices = async (
  medicId: string | number,
): Promise<ISpecialityPrices> => {
  const response = await httpClient.get<
    ConexaResponse<ISpecialityPricesResponse>
  >(
    `/integration/app-paciente/financeiro/obter/valores/profissional/${medicId}`,
  )
  const prices: ISpecialityPrices = {
    immediatePrice: response.data.object.valorImadiato,
    scheduledPrice: response.data.object.valorAgendado,
  }
  return prices
}

export const applyCouponService = async (
  coupon: string,
): Promise<ConexaResponse<CouponApplyingResponse>> => {
  const response = await httpClient.get<ConexaResponse<CouponApplyingResponse>>(
    `coupons/verify/${coupon}`,
  )
  return response.data
}

// `/integration/app-paciente/financeiro/obter/valores/profissional/${profileId}`

//   export const   setDefaultCard(cardId: number | string) {
//     return httpClient.post(
//       `/integration/app-paciente/financeiro/cartoes/marcar-default/${cardId}`,
//     )
//   }

//   export const  addCard(
//     cardOwnerName: string,
//     cardNumber: number,
//     cardSecurityCode: number,
//     cardValidity: string,
//     defaultCardFlag: boolean,
//     cardType: 'CREDIT' | 'DEBIT',
//     cardFlag: string,
//   ) {
//     return httpClient
//       .post('/integration/app-paciente/financeiro/cartoes/salvar', {
//         nomeCartao: cardOwnerName,
//         numeroCartao: cardNumber,
//         codigoSegurancaCartao: cardSecurityCode,
//         validadeCartao: cardValidity,
//         flagCartaoDefault: defaultCardFlag,
//         tipo: cardType.toUpperCase(),
//         bandeira: cardFlag,
//       })
//       .then(res => {
//         return res.data.object
//       })
//   }

//   //evento appsflyer
//   export const startCheckoutAppsFlyer(mode: string, price: string | number, spec: number) {
//     return httpClient.post(
//       '/integration/app-paciente/appsflayer/enviar/iniciocheckout',
//       {
//         modoAtendimento: mode,
//         valorConsulta: price,
//         idEspecialidade: spec,
//       },
//     )
//   }

//   export const getUserData() {
//     return httpClient.get('/usuario/meusdados').then(res => {
//       return res.data.object.usuario
//     })
//   }

//   export const searchCep(cep: string) {
//     return axios
//       .get(`https://api.conexasaude.com.br/site/cep/${cep}`)
//       .then(response => response.data.object)
//   }

//   export const getHealthInsuranceCards() {
//     return httpClient.get('/integration/app-paciente/convenios').then(res => {
//       return res.data.object
//     })
//   }

//   export const binIsValid(bin: string | number){
//     return httpClient.get(`integration/app-paciente/financeiro/validar/bin/${bin}/pagamento-debito`).then(res => {
//       return res.data.object.valido
//     })
//   }

// //   getCieloToken(){
// //     return paymentHttpClient.get("/debit/cielo/token")
// //       .then((d) => {
// //         return d && d.data && d.data.access_token
// //       })
// //   },

export async function requestPixPayment(
  params: IRequestPixPaymentParams,
  cancelToken: CancelToken,
) {
  const res = await httpClient.post<
    ConexaResponse<IRequestPixPaymentResponseRaw>
  >(
    `integration/app-paciente/financeiro/pagar/pix/v2`,
    PixPaymentMapper.toPersistence(params),
    {
      cancelToken,
    },
  )

  return PixPaymentMapper.toDomain(res.data.object)
}

export async function validateTransaction(chargeId: string) {
  const res = await httpClient.get(
    `/integration/app-paciente/financeiro/transacao/${chargeId}`,
  )

  return ValidateTransactionMapper.toDomain(res.data.object)
}

export async function requestImmediatePix(data: IRequestImmediate) {
  const res = await httpClient.post(
    `/integration/app-paciente/atendimento/novo/imediato`,
    RequestImmediatePixMapper.toPersistence(data),
  )

  return res.data.object
}

export async function requestScheduleAttendancePix(data: IRequestScheduled) {
  const res = await httpClient.post(
    `/integration/app-paciente/atendimento/novo/agendado/v2`,
    RequestScheduleAttendancePixMapper.toPersistence(data),
  )
  return res.data.object
}

export async function getRecurrencePossibility(id: string) {
  const res = await httpClient.get<IConexaResponse<boolean>>(
    `/integration/app-paciente/verifica-possibilidade-recorrencia/${id}`,
  )

  return res.data.object
}

export async function createAttendanceRecurrence(
  data: CreateAttendanceRecurrenceParams,
) {
  const res = await httpClient.post<IConexaResponse<boolean>>(
    '/integration/app-paciente/criar-recorrencia',
    CreateAttendanceRecurrenceMapper.toPersistence(data),
  )

  return res.data.object
}

export const confirmReservationConsultation = async (
  data: ConfirmReservationConsultationData,
): Promise<boolean> => {
  const response = await httpClient.put(
    `/integration/app-paciente/atendimento/reserva/confirmar/${data.appointment.id}`,
    ConfirmReservationConsultationMapper.toDomain(data),
  )

  return response?.data?.object
}
